<div class="wrapper-config-menu menu">

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header menu-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config    [device]="device"   [elementChoosing]="objectChoosing" [width]="class['information']['width']" [height]="class['information']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">

      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
              </app-hide-show-config>
        </div>
      </li>

      <!-- HIỂN THỊ NỘI DUNG-->
      <li nz-submenu nzTitle="{{'hien_thi_noi_dung' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="button-size">
          <div *ngFor="let item of menuList" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              {{'an_/_hien_thi' | translate}} {{item.name | translate}}
            </div>
            <nz-switch [(ngModel)]="config.menu_item_hidden[item.key]"
              (ngModelChange)="updateConfig()"></nz-switch>
          </div>

        </div>
      </li>

      <!-- CẤU HÌNH MENU -->
      <li nz-submenu nzTitle="{{'cau_hinh_menu' | translate}}">
        <ul>
          <!-- Định dạnh chữ -->
          <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}" [(nzOpen)]="openMap.menu1"
            (nzOpenChange)="openHandler('menu1')">
            <div class="field-format-font menu-field ">
              <div class="container-font field-font">
                <div class="config-font-size">
                  <!-- Font-family -->
                  <div class="field-row-font" style="width:65%">
                    <mat-form-field style="width:100%">
                      <mat-label>Font</mat-label>
                      <mat-select [(value)]="class['menu__item--content']['font-family']"
                        [(ngModel)]="class['menu__item--content']['font-family']" (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="field-row-size" style="width:35%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                      <input matInput type="number" [ngModel]="class['menu__item--content']['font-size'] | vhnumber"
                        (ngModelChange)="class['menu__item--content']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                                               class['menu__item--content']['font-weight'] == 'bold'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['font-weight'] =
                                                   class['menu__item--content']['font-weight'] == 'bold'
                                                       ? '400'
                                                       : 'bold';
                                               updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                               class['menu__item--content']['font-style'] == 'italic'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['font-style'] =
                                                   class['menu__item--content']['font-style'] == 'normal'
                                                       ? 'italic'
                                                       : 'normal';
                                               updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                               class['menu__item--content']['text-decoration'] == 'underline'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['text-decoration'] =
                                                   class['menu__item--content']['text-decoration'] == 'none'
                                                       ? 'underline'
                                                       : 'none';
                                               updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                               class['menu__item--content']['text-transform'] == 'uppercase'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['text-transform'] =
                                                   class['menu__item--content']['text-transform'] == 'none'
                                                       ? 'uppercase'
                                                       : 'none';
                                               updateClass()">
                      <span>AB</span>
                    </button>

                    <!-- Màu chữ -->
                    <div>
                      <input class="round-input-color" [cpOKButton]="true" [(colorPicker)]="class['menu__item--content']['color']"
                        [style.background]="class['menu__item--content']['color']" (colorPickerClose)="updateObject()"
                        [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                    </div>
                    <!-- Màu chữ -->

                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- Cấu hình màu nền menu -->
          <li class="pl-2" nz-submenu nzTitle="{{'mau_nen_menu' | translate}}" [(nzOpen)]="openMap.menu3"
            (nzOpenChange)="openHandler('menu3')">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBg(background, $event,'menu')"
                nz-tooltip>
              </button>
            </div>
            <div class="color-pick" style="display: flex; align-items: center; justify-content: space-between;">
              <span class="title w-50">{{'chon_mau' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['menu__item']['background-color']"
                [style.background]="class['menu__item']['background-color']" (colorPickerClose)="updateClass()"
                [cpPositionRelativeToArrow]="true" />
            </div>
          </li>

          <!-- Cấu hình màu nền nội dung bên trái -->
          <li class="pl-2" nz-submenu nzTitle="{{'mau_nen_noi_dung_ben_trai' | translate}}" [(nzOpen)]="openMap.menu4"
            (nzOpenChange)="openHandler('menu4')">

            <div class="color-pick" style="display: flex; align-items: center; justify-content: space-between;">
              <span class="title w-50">{{'chon_mau' | translate}}</span>
              <input class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['information__menu']['background-color']"
                [style.background]="class['information__menu']['background-color']" (colorPickerClose)="updateClass()"
                [cpPositionRelativeToArrow]="true" />
            </div>
          </li>
          <!-- Cấu hình màu nền nội dung bên trái -->

        </ul>
      </li>

      <!-- HIỆU ỨNG MENU -->
      <li nz-submenu nzTitle="{{'hieu_ung_menu' | translate}}">
        <ul>
          <!-- Màu khi chạm -->
          <li *ngIf="device == 'desktop'" class="pl-2" nz-submenu nzTitle="{{'mau_khi_cham' | translate}}">
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width:50%; max-width:50%;">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_hover_menu_item.color"
                  [style.background]="config.desktop_hover_menu_item.color" (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <div class="config-name">
              <p>{{'mau_nen' | translate}} </p>
              <div style="width:50%; max-width:50%;">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_hover_menu_item.background_color"
                  [style.background]="config.desktop_hover_menu_item.background_color"
                  (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <div class="field-timeline">
              <div class="config-name mb-0">
                <p>{{'thoi_gian' | translate}}(s)</p>
                <nz-input-number [nzMin]="0.3" [nzStep]="0.1" [nzMax]="1"
                  [(ngModel)]="config.desktop_hover_menu_item.transition" (nzBlur)="updateObject()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0.3" [nzStep]="0.1" [nzMax]="1"
                [(ngModel)]="config.desktop_hover_menu_item.transition" (nzOnAfterChange)="updateObject()">
              </nz-slider>
            </div>
          </li>
          <!-- Màu khi chạm -->

          <!-- Màu khi chọn -->
          <li  class="pl-2" nz-submenu nzTitle="{{'mau_khi_chon' | translate}}">
            <div class="field-format-font menu-field ">
              <div class="container-font field-font">
                <div class="config-font-size">
                  <!-- Font-family -->
                  <div class="field-row-font" style="width:65%">
                    <mat-form-field style="width:100%">
                      <mat-label>Font</mat-label>
                      <mat-select [(value)]="class['menu__item-content--active']['font-family']"
                        [(ngModel)]="class['menu__item-content--active']['font-family']"
                        (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="field-row-size" style="width:35%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                      <input matInput type="number"
                        [ngModel]="class['menu__item-content--active']['font-size'] | vhnumber"
                        (ngModelChange)="class['menu__item-content--active']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                                               class['menu__item-content--active']['font-weight'] == 'bold'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['font-weight'] =
                                                   class['menu__item-content--active']['font-weight'] == 'bold'
                                                       ? '400'
                                                       : 'bold';
                                               updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                               class['menu__item-content--active']['font-style'] == 'italic'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['font-style'] =
                                                   class['menu__item-content--active']['font-style'] == 'normal'
                                                       ? 'italic'
                                                       : 'normal';
                                               updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                               class['menu__item-content--active']['text-decoration'] == 'underline'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['text-decoration'] =
                                                   class['menu__item-content--active']['text-decoration'] == 'none'
                                                       ? 'underline'
                                                       : 'none';
                                               updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                               class['menu__item-content--active']['text-transform'] == 'uppercase'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['text-transform'] =
                                                   class['menu__item-content--active']['text-transform'] == 'none'
                                                       ? 'uppercase'
                                                       : 'none';
                                               updateClass()">
                      <span>AB</span>
                    </button>

                    <!-- Màu chữ -->
                    <div>
                      <input class="round-input-color" [cpOKButton]="true" [(colorPicker)]="class['menu__item-content--active']['color']"
                        [style.background]="class['menu__item-content--active']['color']"
                        (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                    </div>
                    <!-- Màu chữ -->

                  </div>
                </div>
              </div>
              <div class="config-name" style="display: flex; justify-content: space-between; align-items: center;">
                <p style="margin: 0;">{{'mau_nen' | translate}} </p>
                <div style="width:50%; max-width:50%;">
                  <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                    [cpOKButton]="true" [(colorPicker)]="class['menu__item--active']['background-color']"
                    [style.background]="class['menu__item--active']['background-color']"
                    (colorPickerClose)="updateObject()" />

                </div>
              </div>
            </div>
          </li>
          <!-- Màu khi chọn -->

        </ul>

      </li>
      <!-- HIỆU ỨNG MENU -->

      <!-- Cấu hình nội dung bên phải -->
      <li nz-submenu nzTitle="{{'cau_hinh_noi_dung_ben_phai' | translate}}">
        <!-- <ul>
          <div class="field-format-font menu-field ">
            <div class="config-name" style="display: flex; justify-content: space-between; align-items: center;">
              <p style="margin: 0;">{{'mau_nen' | translate}} </p>
              <div style="width:50%; max-width:50%;">
                <input class="input-color w-100" type="button"
                  [cpOKButton]="true" [(colorPicker)]="class['information__right']['background-color']"
                  [style.background]="class['information__right']['background-color']"
                  (colorPickerClose)="updateClass()" [cpWidth]="'230px'" 
                />
              </div>
            </div>
          </div>
        </ul> -->

        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['information__right']['background-color']"
            [style.background]="class['information__right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>

        <div class="color-pick">
          <span class="title w-50">{{'mau_nut_chua_chon' | translate}}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['-btn-right']['background-color']"
            [style.background]="class['-btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
        <div class="color-pick">
          <span class="title w-50">{{'mau_nut_da_chon' | translate}}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['+btn-right']['background-color']"
            [style.background]="class['+btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
      </li>
      <!-- Cấu hình nội dung bên phải -->

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['information']"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
    </ul>

  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['information']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>